import axios from 'axios';

import { GetWalletResponseBody } from '@sparkplug/lib';

import { useApp } from '@hooks/AppHooks';
import { GetCacheKeyFn, useAdvancedQuery } from '@hooks/QueryHooks';

const API = {
    getCurrentUserWallet: async () => {
        return (await axios.get<GetWalletResponseBody>('/api/v1/wallet')).data;
    },
};

export const getUserWalletQueryKey: GetCacheKeyFn = (userId) => ['wallet', userId];
export const useCurrentUserWallet = () => {
    const { user } = useApp();

    const { isFetched: currentUserWalletIsReady, data: currentUserWallet } = useAdvancedQuery(
        getUserWalletQueryKey(user?._id!),
        () => API.getCurrentUserWallet(),
        { enabled: !!user?._id },
    );

    return {
        currentUserWalletIsReady,
        currentUserWallet: {
            ...currentUserWallet,
            deposits: currentUserWallet?.deposits.filter((deposit) => !deposit.expiredAt) || [],
        },
        currentUserWalletWithExpiredDeposits: currentUserWallet,
    };
};

export const useSparkUserDeposit = (sparkId: string, multiLeaderboardSparkIds?: string[]) => {
    const { currentUserWalletIsReady: userDepositIsReady, currentUserWalletWithExpiredDeposits } =
        useCurrentUserWallet();

    const userDeposit = currentUserWalletWithExpiredDeposits?.deposits.find((deposit) => {
        // First check if deposit matches the main sparkId
        if (sparkId === deposit.sparkId) {
            return true;
        }

        // For multi-leaderboard sparks, also check if deposit matches any grouped spark IDs
        if (multiLeaderboardSparkIds && multiLeaderboardSparkIds.length > 0) {
            return multiLeaderboardSparkIds.includes(deposit.sparkId || '');
        }

        return false;
    });

    return {
        userDepositIsReady,
        userDeposit,
    };
};
